import React from "react";
import { ReactComponent as NoChat } from "../../../assets/images/ChatImages/nochat.svg";

const NoChatAvailable = ({ message }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "calc(100vh - 15em)",
        color: "#405261",
        fontSize: "14px",
        fontWeight: "400",
      }}
    >
        {/* <NoChat/> */}
      <p
        style={{
          color: "#405261",
          fontSize: "14px",
          fontWeight: "400",
        }}
      >
        {message}
      </p>
    </div>
  );
};

export default NoChatAvailable;
